import { Box, Flex, Heading, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiShield, FiSmartphone, FiCheckCircle, FiLock } from "react-icons/fi";
import { CyberspaceButton } from "../../components/CyberspaceButton";
import { startCyberspaceOAuth } from "../../utils/cyberspaceAuth";

const STEPS = [
  { icon: FiShield, text: "Przejdź do Cyberspace (zakładasz konto, jeśli go nie masz)" },
  { icon: FiSmartphone, text: "Potwierdzasz tożsamość aplikacją mObywatel" },
  { icon: FiCheckCircle, text: "Wracasz tutaj zweryfikowany i możesz zagłosować" }
];

export const VerifyView: React.FC = () => {
  const [params] = useSearchParams();
  const redirectPath = params.get("redirect") ?? undefined;

  useEffect(() => {
    document.title = "Weryfikacja tożsamości";
  }, []);

  return (
    <Flex minH="100vh" bg="#F7F5FB" align="center" justify="center" px="20px" py={{ base: "40px", md: "56px" }}>
      <Box w="100%" maxW="500px" bg="white" borderRadius="24px" boxShadow="0 18px 50px rgba(67,0,152,0.10)" border="1px solid rgba(67,0,152,0.06)" p={{ base: "32px 24px", md: "44px 40px" }}>
        <Flex w="64px" h="64px" align="center" justify="center" borderRadius="18px" bg="rgba(67,0,152,0.08)" mb="20px">
          <Icon as={FiShield} boxSize="30px" color="primary" />
        </Flex>

        <Heading fontSize={{ base: "24px", md: "27px" }} fontWeight="800" color="primary" mb="8px">
          Zweryfikuj swoją tożsamość
        </Heading>
        <Text color="gray.500" fontSize="15px" mb="26px" lineHeight="1.55">
          To głosowanie wymaga potwierdzenia tożsamości. Weryfikację przeprowadzisz bezpiecznie przez Cyberspace —
          z użyciem aplikacji <strong>mObywatel</strong>.
        </Text>

        <VStack align="stretch" spacing="14px" mb="28px">
          {STEPS.map((s, i) => (
            <HStack key={i} spacing="13px" align="flex-start">
              <Flex w="34px" h="34px" align="center" justify="center" borderRadius="10px" bg="rgba(67,0,152,0.06)" flexShrink={0}>
                <Icon as={s.icon} boxSize="17px" color="primary" />
              </Flex>
              <Text fontSize="14px" color="gray.700" pt="6px">
                {s.text}
              </Text>
            </HStack>
          ))}
        </VStack>

        <CyberspaceButton label="Zweryfikuj przez" onClick={() => startCyberspaceOAuth({ purpose: "verify", redirectPath })} />

        <HStack spacing="8px" mt="18px" align="flex-start">
          <Icon as={FiLock} boxSize="14px" color="gray.400" mt="3px" flexShrink={0} />
          <Text fontSize="12.5px" color="gray.400" lineHeight="1.5">
            Twoje dane z mObywatela zostają w Cyberspace — do nas trafia wyłącznie potwierdzenie, że jesteś zweryfikowany.
          </Text>
        </HStack>

        <Box textAlign="center" mt="22px">
          <Text as={Link} to="/" fontSize="13px" color="gray.400" _hover={{ color: "primary" }}>
            Wróć na stronę główną
          </Text>
        </Box>
      </Box>
    </Flex>
  );
};
